import { NavLink } from "react-router-dom";
import Logo from "../../assets/Logo(500x500).png";

const steps = [
  {
    step: "1",
    title: "Set your criteria",
    desc: "Define what you’re looking for—keywords, subreddits or LinkedIn search.",
  },
  {
    step: "2",
    title: "Scouts find leads daily",
    desc: "AI matches posts to your profile. New leads land in your dashboard and inbox.",
  },
  {
    step: "3",
    title: "Engage and close",
    desc: "Reply while intent is high. One place to track and follow up.",
  },
];

export default function AuthPanel() {
  return (
    <div className="hidden flex-1 flex-col justify-between bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-10 lg:flex xl:p-12">
      <NavLink to="/" className="inline-flex items-center gap-2">
        <img src={Logo} alt="LeadZLab" className="h-9 w-auto rounded-lg" />
      </NavLink>

      <div className="mx-auto w-full max-w-md px-2">
        <p className="text-sm font-medium uppercase tracking-wider text-emerald-400">
          Reddit & LinkedIn lead generation
        </p>
        <h2 className="mt-3 text-2xl font-bold leading-tight text-white xl:text-3xl">
          Find high-intent leads where they’re already talking.
        </h2>
        <p className="mt-3 text-sm text-slate-400 leading-relaxed">
          Set up scouts once. Get qualified leads in your dashboard and inbox—so you can reply first and close more.
        </p>

        {/* Infographic: 3 steps — card so it stands out on dark background */}
        <div className="mt-8 rounded-xl border border-slate-600/60 bg-slate-800/70 px-5 py-4 shadow-lg">
          <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-emerald-400">
            How it works
          </p>
          <ul className="space-y-4" role="list">
            {steps.map((item) => (
              <li key={item.step} className="flex items-start gap-3">
                <span
                  className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-500 text-sm font-bold text-white shadow-md"
                  aria-hidden
                >
                  {item.step}
                </span>
                <div className="min-w-0 pt-0.5">
                  <p className="font-semibold text-white">{item.title}</p>
                  <p className="mt-0.5 text-sm leading-snug text-slate-400">{item.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <p className="text-xs text-slate-500">© LeadZLab</p>
    </div>
  );
}
